import type { RouteComponentProps } from "react-router-dom";

import type { BreadcrumbTrailItem } from "~/common/redesign-v1/components/app-shell";

import { createRedesignEntry } from "../redesign-page-entry";

function patientCrumb(patientId: string): BreadcrumbTrailItem {
  return {
    id: "redesign.shell.patient",
    defaultMessage: "Patient {id}",
    values: { id: patientId },
    to: `/pages/patient/${patientId}`,
  };
}

export const NewPatientRedesignEntry = createRedesignEntry(() => import("./patient-form-redesign").then((m) => ({ default: m.NewPatientRedesign })), {
  testId: "rd-patient-form-loading",
  shell: { activeNav: "patients", breadcrumbLeaf: { id: "left.menu.add_patient", defaultMessage: "Add patient" } },
});

export const EditPatientRedesignEntry = createRedesignEntry<RouteComponentProps<{ patient_id: string }>>(() => import("./patient-form-redesign").then((m) => ({ default: m.EditPatientRedesign })), {
  testId: "rd-patient-form-loading",
  shell: (props) => {
    const patientId = props.match?.params?.patient_id;
    return {
      activeNav: "patients",
      breadcrumbTrail: patientId ? [patientCrumb(patientId)] : undefined,
      breadcrumbLeaf: { id: "BTN_EDIT", defaultMessage: "Edit" },
    };
  },
});
